import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BookOpen } from 'lucide-react';
import MathRenderer from '../math/MathRenderer';

interface WorkedSolutionPanelProps {
  solution: string | null | undefined;
  isVisible?: boolean;
}

const WorkedSolutionPanel: React.FC<WorkedSolutionPanelProps> = ({
  solution,
  isVisible = true
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasSolution = !!solution;

  if (!hasSolution) {
    return null;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div className="mt-4">
      {/* Toggle Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between px-4 py-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors"
      >
        <div className="flex items-center space-x-2">
          <BookOpen className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          <span className="font-medium text-blue-900 dark:text-blue-100">
            {isExpanded ? 'Hide Worked Solution' : 'View Worked Solution'}
          </span>
        </div>
        {isExpanded ? (
          <ChevronUp className="h-5 w-5 text-blue-600 dark:text-blue-400" />
        ) : (
          <ChevronDown className="h-5 w-5 text-blue-600 dark:text-blue-400" />
        )}
      </button>

      {/* Solution Content */}
      {isExpanded && (
        <div className="mt-3 p-6 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg">
          <div className="prose prose-sm dark:prose-invert max-w-none overflow-x-auto">
            <div className="text-gray-900 dark:text-gray-100 space-y-4">
              <MathRenderer latex={solution} />
            </div>
          </div>

          {/* Helpful note */}
          <div className="mt-4 pt-4 border-t border-gray-300 dark:border-gray-600">
            <p className="text-xs text-gray-500 dark:text-gray-400 italic">
              💡 Study the worked solution to understand the methodology and approach
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkedSolutionPanel;
